

import { FieldType } from './enum'
import { debounce } from '@/utils'

import Manual from './manual.vue'
import manualContainer from './manualContainer.vue'
import History from './history.vue'

export default {
    props: {
        filter: {
            type: Object,
            requried: true
        },
        filterOptions: {
            type: Array,
            default: () => [],
            requried: true
        },
        goodsCatalogueId: {
            type: [Number, String],
            requried: true
        },
        gameId: {
            type: [Number, String],
            requried: true
        },
        isGeneralGoods: {
            type: Boolean,
            default: false
        }
    },
    components: {
        manualContainer,
        Manual,
        History
    },
    data() {
        return {
            keyword: '', // 搜索关键词
            searchLoading: false, // 搜索加载状态
            manualOptions: [],
            showManualPopup: false,
            showHistoryPopup: false,
        }
    },
    watch: {
        keyword(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.showManualPopup = !!newVal.trim()
                if (!oldVal && this.showManualPopup) {
                    this.$nextTick(() => {
                        this.$refs.searchInput.focus()
                    })
                }
            }
            if (newVal) {
                this.debouncedSearch(newVal)
            } else {
                this.manualOptions = []
            }
        }
    },
    methods: {
        debouncedSearch: debounce(function () {
            this.searchGoodsPropertyOptions(this.keyword)
        }, 100),
        /**
         * 获取平铺后的选项列表（用于级联选项的扁平化处理）
         * @param category 分类对象
         * @returns 平铺后的选项数组
         */
        getOptions(category) {
            const flattenOptions = []

            /**
             * 递归平铺级联选项
             * @param obj 当前处理的对象
             * @param parentCascadeObj 父级级联对象
             * @param level 当前层级
             */
            function flattenCascadeOptions(obj, parentCascadeObj, level) {
                obj.options?.forEach(option => {
                    // 构建当前选项的级联对象
                    const currentCascadeObj = { ...parentCascadeObj }

                    if (level > 0) {
                        currentCascadeObj[level] = {
                            id: obj.id,
                            name: obj.name,
                            nickname: obj.nickname,
                            options: obj.options || []
                        }
                    }

                    // 如果有子选项，递归处理
                    if (option.options && option.options.length > 0) {
                        flattenCascadeOptions(option, currentCascadeObj, level + 1)
                    }
                    else {
                        // 将当前选项添加到平铺列表中，并设置级联对象
                        const finalCascadeObj = { ...currentCascadeObj }
                        finalCascadeObj[level + 1] = {
                            id: option.id,
                            name: option.name,
                            nickname: option.nickname,
                            options: option.options || []
                        }

                        flattenOptions.push({
                            ...option,
                            cascadeObj: finalCascadeObj
                        })
                    }
                })
            }

            flattenCascadeOptions(category)
            return flattenOptions
        },

        /**
         * 根据关键词搜索商品筛选属性选项
         * @param searchKeyword 搜索关键词
         */
        async searchGoodsPropertyOptions(searchKeyword) {
            if (!searchKeyword.trim()) {
                return
            }

            try {
                this.searchLoading = true
                const _response = await this.$api.getGoodsPropertyOptionsSearch({
                    gameId: this.gameId,
                    goodsCatalogueId: this.goodsCatalogueId,
                    keyword: searchKeyword
                })

                if (_response.success) {
                    // 过滤并处理搜索结果
                    this.manualOptions = _response.data.list
                        .filter((item) => [
                            FieldType.SINGLE,
                            FieldType.LABEL,
                            FieldType.CHECKBOX,
                            FieldType.SINGLE_CASCADE,
                            FieldType.SECTION
                        ].includes(item.fieldType))
                        .map((item) => {
                            // 合并当前筛选状态
                            const fl = this.filterOptions.find(option => option.id === item.id) || {}
                            return {
                                ...item,
                                ...fl,
                                expand: false, // 默认收起状态
                                manualOptions: this.getOptions(item) // 获取平铺后的选项
                            }
                        })
                }
            }
            catch (error) {
                console.error('关键词搜索失败:', error)
            }
            finally {
                this.searchLoading = false
            }
        },
        goAdvisePage() {
            window.open(`/advise`, '_blank')
        },
        /**
        * 处理清空关键词并导航到分组的事件
        * @param groupId 要导航到的分组ID
        */
        handleClearKeywordAndNavigate(groupId) {
            // 清空搜索关键词
            this.keyword = ''
            // 隐藏手动搜索弹窗
            this.onCloseManualPopup()
            // 等待DOM更新后再滚动到指定分组
            const filterSectionTop = document.getElementById('filter-section')?.offsetTop || 0
            if (filterSectionTop) {
                window.scrollTo({
                    top: filterSectionTop - 100,
                    behavior: 'smooth'
                })
            }

            // nextTick(() => {
            //     // 通过引用调用List组件的滚动方法
            //     if (listRef) {
            //         listRef.scrollToAnchor(groupId)
            //     }
            // })
        },
        /**
         * 关闭手动搜索弹窗
         */
        onCloseManualPopup() {
            debugger
            this.showManualPopup = false
            this.keyword = ''
        },
        onScroll() {
            this.$nextTick(() => {
                this.$refs.searchInput?.blur()
            })
        },
        /**
        * 处理历史记录的再次搜索
        * @param data 历史筛选数据
        */
        onReSearch(data, filterData) {
            this.$emit('reSearch', data, filterData)
        }
    },
    mounted() { }
}
